module.exports = {
  
  allowSignup: (allow) => {
    if (allow == false) throw "Not allowed to sign up.";
  },
  
  
  cookie: (cookie) => {
    if (cookie == undefined) throw "cookie is undefined";
    if (cookie == "") throw "cookie is empty";
    if (cookie.length != 32) throw "cookie is invalid";
  },
  
  
  csrf: (csrf) => {
    if (csrf == undefined) throw "CSRF is undefined";
    if (csrf == "") throw "CSRF is empty";
    if (csrf.length != 32) throw "CSRF is invalid";
  },
  
  
  obfuscatedId: (obfuscatedId) => {
    if (obfuscatedId == undefined) throw "obfuscatedId is undefined";
    if (obfuscatedId == "") throw "obfuscatedId was not sent";
    if (obfuscatedId.length != 32) throw "obfuscatedId was not sent correctly";
  },
  
  
  userIsAdmin: (isAdmin) => {
    // validate user is authorized to do this.
    if (isAdmin != true) throw "User is not authorized to complete this function";
  },
  
  
  name: (name) => {
    if (name == undefined) throw "Name is undefined";
    if (name == "") throw "Please type a Name";
    if (name.length < 2) throw "Name isn't long enough";
    // add a regex here to enforce letters and spaces only
  },
  
  
  email: (email) => {
    if (email == undefined) throw "Email is undefined";
	
    // validate email
    if (email != "") {
      // quickly verify email and check email length
      let check = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let validated = check.test(email);
      
      if (validated == false) {
        throw "Email address sent not in a valid format";
      }
    } else {
      throw "Please type an email.";
    }
  },
  
  
  textCode: (code) => {
    if (code == undefined) throw "textCode code is undefined";
    if (code == "") throw "textCode code is empty";
    if (code.length != 6) throw "textCode code not correct length";
  },
  
  
  // handles multiple emails separated by commas
  emails: (email) => {
    if (email == undefined) throw "Email is undefined";
  
    if (email != "") {
      // first split strings based on commas, to validate multiple email addresses
      let emails = email.split(",");
      
      // do a loop to loop through each found email address to validate
      for (let i in emails) {
        
        // trim each email address for whitespace
        let tem = emails[i].trim();
        
        // find < and split string to check email address, if it exists and is valid
        let emailToVerify = tem.split("<");
        // if length == 0, the email address should be in [0], otherwise it will be in [1]
        emailToVerify = emailToVerify.length == 1 ? emailToVerify[0] : emailToVerify[1].slice(0, emailToVerify[1].length-1);
        // use a basic regexp to verify the email
        let check = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let validated = check.test(emailToVerify);
        if (validated == false) {
          throw "Email address sent not in a valid format. " + email;
        }
      }
    } else {
      throw "Email address was sent empty."
    }
  },
  
  
  privateKey: (privateKey) => {
    if (privateKey == undefined) throw "privateKey is undefined";
    if (privateKey == "") throw "Your key was sent incorrectly";
  },
  
  
  boolean: (b) => {
    if (b == undefined) throw "Boolean is undefined.";
    if (b != true && b != false) throw "Boolean was sent incorrectly";
  },
  
  
  resetId: (id) => {
    if (id == undefined) throw "resetId is undefined";
    if (id == "") throw "resetId was not sent";
    if (id.length != 32) throw "resetId was not sent correctly";
  },
  
  
  encryptedResource: (resource) => {
	  if (resource.includes("-----BEGIN PKCS7-----") == false || resource.includes("-----END PKCS7-----") == false) throw "Incorrectly sent encrypted resource";
  },
  
  
  // an encrypted hash that has been hexed
  hash: (hash) => {
    if (hash == undefined) throw "hash is undefined";
    let check = /[a-f0-9]/g;
    let validated = check.test(hash);
    if (validated == false)	throw "incorrectly sent hash";
  },
  
  
  hashedIndex: (index) => {
    if (index == undefined) throw "hashedIndex is undefined";
    let check = /[a-f0-9]/g;
    for (let i in index) {
      let validated = check.test(index[i]);
      if (validated == false)	throw "Incorrectly sent hashed index";
    }
  },
  
  
  // assumes mysql style date time (2022-03-16 13:30:00)
  datetime: (date) => {
    if (date == undefined) throw "datetime is undefined";
    let check = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    let validated = check.test(date);
    if (validated == false)	throw "Incorrectly sent datetime";
  },
  
  
  // assumes mysql style date (2022-03-16)
  date: (date) => {
    if (date == undefined) throw "date is undefined";
    let check = /^\d{4}-\d{2}-\d{2}$/;
    let validated = check.test(date);
    if (validated == false)	throw "Incorrectly sent date";
  },
  
  
  // assumes mysql style date time (13:30:00)
  time: (time) => {
    if (time == undefined) throw "time is undefined";
    let check = /^\d{2}:\d{2}:\d{2}$/;
    let validated = check.test(time);
    if (validated == false)	throw "Incorrectly sent time";
  },
  
  
  string: (string, message) => {
    if (message == undefined) message = "string";
    if (string == undefined) throw message + " is undefined";
    if (string == "") throw message + " is empty";
  },
  
  
  // implements a length limit on a string
  stringLengthLimit: (string, limit, message) => {
    if (message == undefined) message = "string";
    if (string == undefined) throw message + " is undefined";
    if (string == "") throw message + " is empty";
    if (string.length > limit) throw message + " is too long";
  },
  
  
  // validates a string against a group of strings
  contains: (contains, group, message) => {
    if (message == undefined) message = "string";
    if (contains == undefined) throw "contains is undefined";
    if (contains == "") throw "contains is empty";
    if (group == undefined) throw "group is undefined";
    if (typeof group != "object") throw "group is wrong type - should be an array";
    if (group.length == 0) throw "group is empty";
    
    if (group.includes(contains) == false) throw message + " is not provided";
  },
  
  
  integer: (i) => {
    if (i == undefined) throw "Integer is undefined.";
    if (Number.isInteger(i) == false) throw "Integer was sent incorrectly";
  },
  
  
  pageNumber: (i) => {
    if (i == undefined) throw "pageNumber is undefined.";
    if (Number.isInteger(i) != true) throw "pageNumber was sent incorrectly.";
    if (i < 0) throw "pageNumber was not positive."
  },
  
  
  // takes an array of strings and validates that the input matches one of the array entries
  // must be exact matches
  // shouldBe converted to "contains: () => {}"
  shouldBe: (input, matchTo) => {
    for (let i in matchTo) {
      if (matchTo[i] == input) {
        return;
      }
    }
    
    throw "No exact matches in shouldBe()";
  },
  
  
  uid: (id) => {
    if (id == undefined) throw "uid is undefined";
    if (id == "") throw "uid is empty";
    if (id.length < 16) throw "uid is too short";
    if (id.length > 16) throw "uid is too long";
  },
  
  
  photoId: (id) => {
    if (id == undefined) throw "photoId is undefined";
    if (id == "") throw "photoId is empty";
    if (id.length < 16) throw "photoId is too short";
    if (id.length > 16) throw "photoId is too long";
  },
  
  
  phone: (phone) => {
    if (phone == undefined) throw "phone is undefined";
    if (phone == "") throw "phone is empty";
    if (phone.length < 10) throw "phone is too short";
    
    let check = /^[0-9\-\(\)\. ]+$/;
    let validated = check.test(phone);
    if (validated == false) {
      throw "phone sent not in a valid format";
    }
  },
  
  
  // can only contain letters and numbers
  username: (username) => {
    if (username == undefined) throw "username is undefined";
    if (username == "") throw "username is empty";
    
    let check = /^[A-Za-z0-9_]+$/;
    let validated = check.test(username);
      
    if (validated == false) {
      throw "username sent not in a valid format";
    }
  },
  
  
  password: (password) => {
    if (password == undefined) throw "Password is undefined";
    if (password == "") throw "Password is empty";
    if (password.length < 10) throw "Password is too short";
  },

  
  passwordSalt: (passwordSalt) => {
    if (passwordSalt == undefined) throw "passwordSalt is undefined";
    if (passwordSalt == "") throw "passwordSalt is empty";
  },
  
  
  keys: (keys) => {
    if (keys == undefined) throw "keys is undefined";
    if (keys == "") throw "keys is an empty string";
    
    const count = Object.keys(keys).length;
    if (count == 0) throw "no keys in array";
    if (count < 2 || count > 2) throw "exactly two keys should be present";
    
    if ( ("cert" in keys) == false ) throw "cert is not present";
    if ( ("pkey" in keys) == false ) throw "pkey is not present";
    
    if (keys.cert.includes("-----BEGIN CERTIFICATE-----") == false || keys.cert.includes("-----END CERTIFICATE-----") == false) throw "cert has incorrect format";
    
    if (keys.pkey.includes("-----BEGIN ENCRYPTED PRIVATE KEY-----") == false || keys.pkey.includes("-----END ENCRYPTED PRIVATE KEY-----") == false) throw "pkey has incorrect format";
  },
  
  
  pkey: (pkey) => {
    if ( pkey == undefined) throw "pkey is undefined";
    if ( pkey == "") throw "pkey is empty";
    if (pkey.includes("-----BEGIN ENCRYPTED PRIVATE KEY-----") == false || pkey.includes("-----END ENCRYPTED PRIVATE KEY-----") == false) throw "pkey has incorrect format";
  },
  
  
  
  // a possible shared item
  // '{"data":"863fa3ffa12f4f33f1ba570af928ab9673a225cae07bd888b24b052c7a0010147582b4b54c8849b63618dda51a9ecff3b8eed5b6a7ee896ed684cf1c7c219b4b12a39f1a6f44b99f53879ada2b2b08871388d25c105e8da78616da79892b62c30f40aed8a8bc9f8c3b92e1c9c99d9a4182618ac2eb4e75d736b1be83b39aaee92bee0cb0ab2d932a","key":"a9f309f272170b79b9c73260c3b4b149","iv":"6251ee1949ddc63980ded1af","verify":"a44b5b14a3ca3c09","tag":"4b0639b5b88821bac04572c0ffd7205f"}'
  shared: (shared) => {
    if (shared == undefined) throw "shared is undefined";
    if (shared == "") throw "shared is an empty string";
    
    if (shared.includes("data") == false || shared.includes("key") == false || shared.includes("iv") == false || shared.includes("verify") == false || shared.includes("tag") == false ) throw "shared does not contain all elements";
    
  },
  
  
  key: (key) => {
    if (key == undefined) throw "key is undefined";
    if (key == "") throw "key is empty";
  },
  
  
  tag: (tag) => {
    if (tag == undefined) throw "tag is undefined";
    if (tag == "") throw "tag is empty";
  },
  
  
  isArray: (array) => {
    if (array == undefined) throw "array is undefined";
    if (typeof array != "object") throw "array is not an array";
  },
  
  
  isArrayFilled: (ar, message) => {
    if (message == undefined) message = "array";
    if (ar == undefined) throw message + " is undefined";
    if (ar.length == 0) throw message + " is empty";
  },
  
  
  isObject: (array) => {
    if (array == undefined) throw "array is undefined";
    if (typeof array != "object") throw "array is not an array";
  },
  
  
  image: (im) => {
    if (im == undefined) throw "image is undefined";
    if (im.length == 0) throw "image is empty";
    if (im != "empty" && im.includes("data:image/jpeg;base64,/9j/") == false) throw "image is not valid jpeg";
  },
  
  
  // jpeg file signatures - magic numbers/values
  // https://en.wikipedia.org/wiki/List_of_file_signatures
  // FF D8 FF DB
  // FF D8 FF E0
  // FF D8 FF E1
  // FF D8 FF EE
  // image must be in Uint8Array format
  imageBinary: (image) => {
    if (image == undefined) throw "image is undefined";
    if (image instanceof Uint8Array == false) throw "image is not Uint8Array";
    
    
  },
  
  
  bio: (str) => {
    if (str == undefined) throw "bio is undefined";
    if (str.length > 1000) throw "bio too long";
  },
  
  
  links: (ar) => {
    if (ar == undefined) throw "links is undefined";
  },
  
  
  sixDigitVerification: (sixDigitVerification) => {
    if (sixDigitVerification == undefined) throw "sixDigitVerification is undefined";
    if (sixDigitVerification < 100000 || sixDigitVerification > 999999) throw "sixDigitVerification is incorrect";
  },
  
  
  // countries should be an array of country codes
  country: (country, countries) => {
    if (country == undefined) throw "country is undefined";
    if (country == "") throw "country is empty";
    if (countries == undefined) throw "countries is undefined";
    if (typeof countries != "object") throw "countries is wrong type - should be an array";
    if (countries.length == 0) throw "country is empty";
    
    if (countries.includes(country) == false) throw "country does not exist";
  },
  
  
  float: (float) => {
    if (float == undefined) throw "float is undefined";
    if (isNaN( parseFloat(float) ) == true) throw "float is not a float";
  },
  
  
  // supported currencies
  currency: (currency) => {
    switch (currency) {
      case "$":
        return true;
    }
    throw "currency not supported";
  }
  
}


/*
try {
  module.exports.date("202-19-10");
} catch (error) {
  console.log("error:", error);
}

let data = [
  "1-213-995-7078",
  "(213) 995-7078",
  "+1 (213) 995 7078",
]

for (let i in data) {

  try {
    module.exports.phone(data[i]);
    console.log("phone okay - " + data[i]);
  } catch (error) {
    console.log("error:", error + " " + data[i]);
  }
  
}

console.log(" ");

data = [
  "MyHoney96",
  "lOnGpUppY++",
  "",
]

for (let i in data) {

  try {
    module.exports.username(data[i]);
    console.log("username okay - " + data[i]);
  } catch (error) {
    console.log("error:", error + " " + data[i]);
  }
  
}

console.log(" ");

*/


// let keys = {
//   cert: `-----BEGIN CERTIFICATE-----
// MIIE6DCCAtCgAwIBAgIBATANBgkqhkiG9w0BAQUFADAVMRMwEQYDVQQDEwpzaGFk
// b3dVc2VyMB4XDTIxMDkyODAyMTUwOFoXDTQxMDkyODAyMTUwOFowFTETMBEGA1UE
// AxMKc2hhZG93VXNlcjCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBAJG7
// U0wnw3crrK1jp7rptMqOeeO35UnRHBhAOPOZmAdSOSpPRUWxIYLjSNHonjiZU154
// NzAzuZh10/AO/Fk89zaLhqRfc3FRh+PTwys5LeXmFsv3Um3ePOWudlHmF/9PJ2k9
// wtMSjGljkEZglW953eNveYERsoFfxI4kGYshKkuyQY/824Y9MmL+xIEwU9/O0MZo
// qtHHEobvEFdtNJ/DPbVKXvix1Kvv7yfm0f4FpiKvE1fz0QwKuFhzADbgq9chpjVF
// YCmLj+nvPfKFCfBX2dKcyw9jSDQSm+ANI3IAqMgJTCBSB/HqXCRy5MuCCrcmJiav
// SNyS/CHXYaeH7s0vY3Y/8nMt+eRZoRg/xjnMLEP6CtF8O6xOIY2ADwZzvtaiyDDc
// 0OgM8214JLxKSZ3nM3Ih08JYXSCB9/6xwIW5T4a+xVo+fVUNrsnsYkK6EkW+XmWH
// XlGQShuLJhkqNL+1HvHxjmuApUphtlOb/sxh9diBzU+X60XdSpo0glDq1miXo8B3
// T0ZKnmzQlTAwgN4whB9aseNX5NGkbKEdI71QxKeKH6/FEXyXbvO8RkoVek2nnOwC
// LOf7mTxIIP3zmYjFsVvhTz/Iw3rrE/qv4EaZH2qBKlkziTzV5PLMux8tdYjuJPlN
// nAWe3UEaPrp1bgP3lOcRHygzbY1PnPBDXSgBUkwnAgMBAAGjQzBBMAwGA1UdEwQF
// MAMBAf8wCwYDVR0PBAQDAgL0MCQGA1UdEQQdMBuGGWh0dHBzOi8vaGFuZ2luZ291
// dC50b2RheS8wDQYJKoZIhvcNAQEFBQADggIBAIsD41GpSVgkB6CtJ78tKP4sizq6
// 5wUgiyLkRQWldgNkVwvDIkZYy5m7gjkmuh14N/taok8E5J/YqPjtOeSZ/tLCuZak
// 7o12j7OVRt1RGqBfHbgcJr0mQ+bXRrpDhyQeD1BwTFFN8BTcj5LBOcCj1zUFpeJn
// 9hQv0YzgWKmwauORVsWIC4YT3K6iJXFhPzMDGPBakPzsVKrDiftNnWg/EKYw34h+
// WtgZlRNEsmyerVkK/cv7CFKcA6uJsxoDwbC60FL28dfw+wchvSS3od0lwvcLMAb8
// JUM1bxvEfKmR9UUvSALQf4Xfdw2uRNu28N6T2UAkYhVKAPeUPUTrBiWquYatzTQI
// n5XG7dtr/oj99yvqsS8ORCcyasTI/18yQwswbrGw82DvjbTaNLLpaNczDvspnwdb
// aa+AnaVYgC3j7zlIWpGRzZXGkq3J8d67XY7+wi432x3gVnN9q/93vPEREdbTKlAW
// 7hTzoSpnT1W08uliMfeHoxJv1afmTRx1wz+3LjoNNt1RWLf0UUwyMyX2gcoN1hGZ
// zWgEhEuk2bqzp89ff0AG/Sw96sGiMJjOKbvjlnkqUWZikN1hIsW2OlVPi3DwzUll
// //kqzMTKS/0Z32M35yi08TT271NNVepP+fUYe5E+1bQW0rf0AOh4QvzqFaRHVKeK
// F7Nk2BrCgcu23eje
// -----END CERTIFICATE-----
// `,
  
//   pkey: `  -----BEGIN ENCRYPTED PRIVATE KEY-----
// MIIJnzBJBgkqhkiG9w0BBQ0wPDAbBgkqhkiG9w0BBQwwDgQIlNkJHa5F6m4CAggA
// MB0GCWCGSAFlAwQBAgQQ0oyO8+D5veunLHlgQ9okJgSCCVC/kGOyKGpTWioW2LNC
// aYltuWOUButx//AlTWdTgPH4TYc8yf/vvMGQ+9/Ci+OXeDWEU7EcgweAVrV6wO4n
// D8aqc7XCK3V8hlHKuTZV3cSoxdVr1Nwo4GlAJx/8WwAWsH8U8rXibUOTlBGmubgL
// y2XOwJMau/ptrVmeXBKuHUFNAvsZlFfjuUsFN0+TOF87T3pSdouAyNA8/UoVmZG9
// 3oJcf6erQ3Wb4xthooFy3Y6KGqtjQtj6Zp9B7z8feXIfU+iDAlLJwm//Ldm9xWFI
// 2n0S3h8kEh3iECyt7y3Z51BmttZak2hevbLWztXjF/fhJWdjaTy05+uujafiKg+N
// LREzhgGWGBHdSGEQCctcEY4V5vvQQIshYSmMZRpWoSBr/sF0O8SfXq5OehtS6Uld
// Dl1s2TQDj/ZdIpQmyD7h3roOiFm3J+YA5Sm6oj6scfyirYZi0nof9E2BqkPo9/xW
// qlkF2r7zVma9jxbt03Xj6zp8YGwtckZCQ4vpSaTdHP1o3teYr2XiDC38aKju7Lf5
// F+9XkwPz7gB5QlZLgAXvdBLGGwkn0gVsuRsbWC+UkWKlAxLmgKJXCxNelRxrELGS
// JSLj09fSrcD3QsnEv6xejFkGH0Y+sSeve/k1/TMwdhWn2+7LI4fYAbUovBKomniW
// wnKjmIULH/DEYV+rRmWXKYZy2VPYpULYSv5quF46hzgEJhZpiZRm3BafFz8ay5mr
// 056+S8DpodMoqKP/eInB3hGvUv6r3u38KcX2VC9FQfu1AUAEasYZeCmAjFfJ5TeL
// km82q+/uRzKeYB/wnENUFIq4Ui34oBmKTRgPdK90iE3dR0WjQq0SJBjU3RYA6xEN
// G0aSfdGdxSy+rMuOHiczUjilT5l9pOkZsxYMSVfyYyMlz443nLMyNOK3SVtTlOOf
// atba80luRFBOHLABcLeTHCno+bIGEZXoKA6CHvkhom/6+QBpy0XEqi0S4sV+YLnb
// 2zF4oijG6JTIpcr77Zw986Pv5ERIs+J9XcADnWwNR8pvX1z+bCwCQ9D9Fsjj09lO
// U9ozWV/hn7S1xe5fcUi0O7MxCshD8lrpKIlO/MK+eVBdY9FZagnaYJ4F1kWrptyF
// 2KXGOv8J81OQC7Lmhqmon7Me9NFgPs8sk1q2giVVGj18tKwxSDx+R3U98jBj8wbR
// 4Aht3pWhurh6oeMTV2TZO7LCLKU35O0j6uOuROPUKRqrw8yH053vaBptHwm+jlRz
// TT934rE00HKOqtTJtj/pa7m8gx4suB+06wUctgK0SeBjOSaF/wVEZD9/wcJZ7nFQ
// RKQYPWaJFXckUTBoV1hjYUkRQC/4gcECj3GlSlDKBLpctvXwTGiGIBqLu3PoG9Zn
// SCIYBAYymL1FePlCrbrRUtsXXcTP0Vgau1MlUOi8v2l35jVwBDIgWnPisrKMlYyn
// AkUn38ImbMvkSsDH5juBpSJWZ5Tc+T/xIOZfBqwPAuXYNs+QL3BV3zF9Y4SIEFXq
// 8c1kyUsn3uAseTeKoPP/qNHtsPwYFm6lJWc4xFIFPuGtOtVP4vzSZ3xk81eno1hc
// wrpXp1PXv5HbHeCA2E0f4rUAZTypgn3zN+ojhz2SqJvrrZ7bAox1iymVtPCF2t1d
// A6yB70zSF+Y15polAnqCpR9tqRPX9IgyJ7e1R+3r13A+OuepqzUeylmY17Pztj9u
// 0/9waZwzP8KizJQVYE1DApkR8LjtfIqLuwDHsPnn+gLROkJ8o4vVZullfEI8cTgs
// xoKTiK+vApCv8b9vVJbwgFo8GDXZiInQUmrXRBJebV28jfwC/qhavxPxoNLNcVAZ
// Y5R7aBcL/f4fcagBXxEUfMmul7HdVB1CPrqVkxhc46o2ZdjsgXYrTnJD1kJzaRLd
// elaZxLJOGpIyF6W8epuY4LFZH/GXn/VJPOnwv/mvIqqVD/d5MN6qFdFTTVIhkCjE
// k+z5ad+x0GanHDAx0R8bA1sPP28RsGPLTx8U0iuZVS7U1HA39il1WNhlvrDMkWXN
// z2xXXohApdCcpq+70loAoKionNzh0MgsdYkQD+bL3n+Rj+Ni4rQMDIGvZW3xDJ8O
// Zr5b45neWDZnudKGRYGGGW9FYrMpwGNOu3IQmIO9N1XR4qFSdV4XcJc++623e+Tv
// ZpWPN69rSgdzE9oFuIxADcU2q/gjYmoP7yYbZhVXyYP9QtS+NNgJGD7PRvjQNy5F
// VWjaIubkvYXE3lQ2WvByZSgdWIxiu0x0ILGhKIdwXgqW8JpCC96wM1r9SN6uNIFE
// NLqWDo91eL5Dc2Jz2gLcBt3e4LINf0da2wMf2XUwKQyBV2fVu+R3cAMZrnMSydSQ
// YbmBRkLLe0Ebjddbk5NrjXLnikHMdVtzOTBYJKOTX3ea2OcQe3fKWjOpVqPM3tyc
// cFU6J+Zx9GsX2kKd7bMdDN3TEBzBE04M4UHzKKke9e80rMuUIBFny/3uNq1CrwV4
// eCIcUZ/t5xZTFDJMSaMjBrzi4Su6jNJo7+fvy3+2DO2dYbzu9YVlEnTDva+sYis4
// TXkDg8I6iCkToVovy5Kw4WLNGC/VGjJBA4VobSFsHT/X26a7RnciPtG6qPyt0odC
// 9UQ8IDnQl+WbgosZg4HHjyQcPzSeeqagYpBHW3DEFIqTTMHQOMe+MmAfxpUt+DQu
// lF4WrEBgnMuQydcDIYZcB59fZS257oH1VdofWFHPwX3EQBezrjy8pCOpAH3kAtIm
// LWkQRA+T0EK0gMVD4crrPwIlioqv/STtT+NBZc1PtG35FFhPNYbr+2UgmpTKhX+c
// VuNV1qeUhX783r5PkEA0anxeAb3oOfdxgsYiP9pkpSGL+KO/bZQ19/gKVDD4aygc
// 4WoDyc+1qN2Gb4LqUcDEpXHDBmiM/jTHtKg9AqvDIDovKAtRfKQ8GlCGb2BGgo6o
// IyzAJm5IpJYp/VyDCXyiJwhL3Edcar8CduOI9dvtIhp3BEiIS2FiUQMSMQHgtDrO
// Zs1u8hpDgu3MgUCtO4yz6pLzw+wiisr5Qos7cHUXoFaEjk4PhadKngirVkrDvwBR
// /Ie6EhfVR36Gx5Sq/+GxfJMEfpD8BRv+VV7B/HoxUjtMVcQxpW2ghib7mjL5J2mn
// wpFkTWBAPEGptbHDChnWAuRAQkn5AM4dhDQLUw5EGcYKy6gL1HXs7544B4ykaizk
// rfuqQ9FKxey/LZXOW3090zXe4g==
// -----END ENCRYPTED PRIVATE KEY-----
// `,
// }


// try {
//   module.exports.keys(keys);
//   console.log("keys okay - ");
// } catch (error) {
//   console.log("error:", error + " ");
// }

